// SignupForm.js
import React, { useState } from "react";
// import { Link } from "react-router-dom";
import "./LoginForm.css";
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showSubmitButton, setShowSubmitButton] = useState(true);

  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "email") setEmail(value);
    else if (name === "password") setPassword(value);

    // Show submit button only if all fields are filled except mobile number
    // if ( email && password ) {
    //   setShowSubmitButton(true);
    // } else {
    //   setShowSubmitButton(false);
    // }
  };

  const validatePassword = () => {
    const passwordRegex = /^(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

    if (!passwordRegex.test(password)) {
      alert(
        'Password must contain at least:  one lowercase letter, one special character, one number, and be at least 6 characters long.'
      );
    }
    return passwordRegex.test(password)
  };

  const loginAuthenticate = () =>{
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        console.log('signed in', user)
        localStorage.setItem('userToken', user.uid);
        navigate('/');
        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        alert('CHeck email and password again!')
      });
      }

      const handleSubmit = (event) => {
        event.preventDefault();
        if(validatePassword()){
          loginAuthenticate();
        };
      // Handle form submission logic here
    };

  return (
    <div className="auth-form">
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>

        <input
          type="email"
          name="email"
          placeholder="Email ID"
          value={email}
          onChange={handleInputChange}
          className="inputContainer"
        />
        <input
          type="password"
          name="password"
          placeholder="Enter Password"
          value={password}
          onChange={handleInputChange}
          className="inputContainer"
        />
        {showSubmitButton && (
          <button className="submit-button" type="submit">
            Log In
          </button>
        )}
      </form>
      <div className="login-link">
        {/* <Link to="/login">Already have an account? Log in</Link> */}
      </div>
    </div>
  );
};

export default LoginForm;
